module.exports = __webpack_public_path__ + "img/anhydro.362ee60d.png";